import { render, staticRenderFns } from "./HeaderApp.vue?vue&type=template&id=71224b4e"
import script from "./HeaderApp.vue?vue&type=script&lang=js"
export * from "./HeaderApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports